module.exports = __webpack_public_path__ + "static/img/guide-match-select.1bbe1e9.png";